import teams from "./teams";
export default [
    {
        team1: {...teams[0]},
        team2: {...teams[1]}
    },
    {
        team1: {...teams[1]},
        team2: {...teams[2]}
    },
    {
        team1: {...teams[3]},
        team2: {...teams[4]}
    },
    {
        team1: {...teams[6]},
        team2: {...teams[7]}
    },
    {
        team1: {...teams[8]},
        team2: {...teams[9]}
    },
    {
        team1: {...teams[10]},
        team2: {...teams[11]}
    },
    {
        team1: {...teams[12]},
        team2: {...teams[13]}
    }
];
